import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActivatedRoute } from '@angular/router';
import { OdaAtFirestore } from 'src/app/models/odaAtFirestore.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { environment } from 'src/environments/environment';
import { onSnapshot } from 'firebase/firestore';
import { UtilService } from 'src/app/services/util.service';
import { Menu } from 'primeng/menu';

import { ExcelService } from 'src/app/services/excelService.service';
import { FiltroPratica, PraticaFlowdy2_Firestore } from 'src/app/models/praticaFirestore.model';
import { StiliService } from 'src/app/services/stili.service';
import { UserService } from 'src/app/services/user.service';
import { PraticheService } from 'src/app/services/pratiche.service';
import { Location } from "@angular/common";
import { OdaService } from 'src/app/services/oda.service';
import { ListeService } from 'src/app/services/liste.service';
import { ImportLog_Firestore } from 'src/app/models/firestore/importLogFirestore.model';
import { ScuoleService } from 'src/app/services/scuole.service';
import { GoogleStorageService } from 'src/app/services/googleStorage.service';
import { Impresa } from 'src/app/models/impresa.model';
import { ImpreseService } from 'src/app/services/imprese.service';
import { StoricoPraticaComponent } from '../../shared/storico/storico-pratica.component';
import { v4 as uuidv4 } from 'uuid';
import { StoricoNotePraticaComponent } from '../../shared/note-pratica/note-pratica.component';
import { DialogModificaVincolo } from '../../shared/modifica-vincolo/modifica_vincolo';
import { CategoriaVincolo } from 'src/app/models/categoriaVincolo.model';


declare const CSVBoxImporter: any;
@Component({
    templateUrl: './ko.bando1.component.html',
    styleUrls: ['./ko.bando1.component.css'],
    providers: [DialogService, ConfirmationService],

})
export class PraticheKOBando1Component implements OnInit, OnDestroy {
    protected isLoadingResults:boolean = false;
    protected mostraPraticheCompletate:boolean = false;

    private importID: string; 

    protected showRendiLavorabile:boolean = false;
    
    public isAdmin: boolean                     = false;
    public isSuperAdmin: boolean                = false;
    public isPresidioSF: boolean                = false;
    public isPresidioTIM: boolean               = false;
    public isDirigenteFirmaVerbali: boolean     = false;
    public isDirigenteFirmaPacchetti: boolean   = false;
    public isPM:boolean                         = false;
    public isContabile:boolean                  = false;
    public isImpresa:boolean                    = false;
    public isDemo:boolean                       = false;

    protected pratiche:PraticaFlowdy2_Firestore[] ;
    protected praticheFiltrate:PraticaFlowdy2_Firestore[] ;
    protected selectedPratica:PraticaFlowdy2_Firestore ;

    @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
    @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;

    protected menuAzioniItems!: MenuItem[];
    private _filtroPratiche!: FiltroPratica;

    protected filtroPratica:String;

    protected imprese:Impresa[]=[];
    

    get filtroPratiche(): FiltroPratica {
      return this._filtroPratiche;
    }
    
    set filtroPratiche(value: FiltroPratica) {
      this._filtroPratiche = value;
    }
    
    private collection_pratiche:string = environment.firebase.collection_pratiche;
    private collection_importLog:string = environment.firebase.collection_import_log;

    private ref: DynamicDialogRef;

    protected filterTabellaIsSet:boolean = false;
    protected filterIsSet:boolean = false;
    protected filtroInLavorazione:boolean = false;
    protected filtroLotto:String;
    protected filtroStatoInfratel:String;
    protected filtroOda:String;
    protected filtroDaPagare:boolean = false;
    protected filtroLottoPerFase:String;
    
    private csvbox_licenseKey_importaVincolateBando1:string    =environment.csvBox.secret_importaVincolateBando1;
    private csvbox_importer_vincolateBando1:any;

    protected categorieVincolo:CategoriaVincolo[]=[];

    @ViewChild("praticheDT", { static: true }) praticheDT: any;
    
    constructor(
        private logger: NGXLogger,
        public firestore: AngularFirestore,
        public utilService:UtilService,
        protected stiliService:StiliService,
        private userService:UserService,
        public dialogService: DialogService,
        private messageService: MessageService,
        private excelService:ExcelService,
        private activatedRoute: ActivatedRoute,
        private location: Location,
        protected listeService:ListeService,
        private aziendeService: ImpreseService,
        private praticheService:PraticheService,
      
    ) {
      this._filtroPratiche = {};
      this.setUserRole();
      this.loadImprese();
      this.loadCategorieVincolo();
    }
    loadCategorieVincolo() {
      this.utilService.getTipologieVincolo().subscribe((categorieVincolo) => {
        this.categorieVincolo = categorieVincolo;
       /*  categorieVincolo.forEach(categoria => {
          if(!this.tipologieVincolo.includes(categoria.tipologiaVincolo)){
            this.logger.info(categoria.tipologiaVincolo);
            this.tipologieVincolo.push(categoria.tipologiaVincolo);
          }
        }); */
       
      });
    }
    loadImprese() {
      this.aziendeService.getByBando("1").subscribe((aziende) => {
        this.imprese = aziende;
      });
    }

    ngOnDestroy(): void {
    }

    ngOnInit() {
      this.initCSVBox();
      const urlParamInLavorazione   = this.activatedRoute.snapshot.paramMap.get('lavorazione');
      const urlParamLotto           = this.activatedRoute.snapshot.paramMap.get('lotto');
      const urlParamCodiceInfratel  = this.activatedRoute.snapshot.paramMap.get('stato');
      const urlParamOda             = this.activatedRoute.snapshot.paramMap.get('oda');
      this.activatedRoute.queryParamMap.subscribe((params) => {
        this.filtroDaPagare         = params.get('da-pagare') === 'true';
        this.filtroLottoPerFase     = params.get('lotto');
        this.filtroInLavorazione    = params.get('in-lavorazione')=== 'true';
        this.filtroPratica          = params.get('pratica');
      });
    
      if(this.filtroInLavorazione || this.filtroPratica){
        this.filterIsSet = true;
      }

      /* if(urlParamInLavorazione){
        this.filtroInLavorazione = urlParamInLavorazione;
        this.filterIsSet = true;
      } else  */if(urlParamLotto){
        this.filtroLotto = urlParamLotto;
        this.filterIsSet = true;
      }else if(urlParamCodiceInfratel){
        this.filtroStatoInfratel = urlParamCodiceInfratel;
        this.filterIsSet = true;
      }else if(urlParamOda){
        this.filtroOda = urlParamOda;
        this.filterIsSet = true;
      }
       this.loadPratiche();
    }

    initCSVBox(){
          this.csvbox_importer_vincolateBando1 = new CSVBoxImporter(this.csvbox_licenseKey_importaVincolateBando1, {
          }, (result: boolean, data: any) => {
            if (result) {
              this.readImportLog();  
            } else {
              this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di import delle pratiche vincolate del bando 1', life:10000});
            }
          });
          
          
          
          this.csvbox_importer_vincolateBando1.setUser({
            user_id: "default123"
          });
        
         
          this.csvbox_importer_vincolateBando1.language="it";
          
        
        }
    
        readImportLog(){
          const collectionRef = this.firestore.collection(this.collection_importLog).ref;
          let queryErrori ;
          queryErrori = collectionRef.where("id", "==", this.importID);
          
          onSnapshot(queryErrori, (qs) => {
            this.isLoadingResults = false;
            qs.forEach((doc) => {
                let log: ImportLog_Firestore = doc.data() as ImportLog_Firestore;
                if(!log.errori || log.errori.length == 0){
                  if(!log.warning || log.warning.length == 0){
                    if(log.numeroRecordNonProcessati!=0){
                      if(log.numeroRecordNonProcessati==1){
                        this.messageService.add({severity:'success', summary:'', detail: 'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non è stata processata', life:10000});
      
                      }else {
                        this.messageService.add({severity:'success', summary:'', detail: 'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non sono state processate', life:10000});
      
                      }
                    }else{
                      this.messageService.add({severity:'success', summary:'', detail: 'Tutte le ' + log.numeroTotaleRecord+ ' pratiche presenti nel file sono state processate con successo', life:10000});
      
                    }
      
                  }else{
                    this.messageService.add({severity:'warn', summary:'Warning', detail:'Il caricamento degli esiti della consegna ad INFRATEL della FASE 1 si è concluso con '+ log.numeroRecordNonProcessati +' warning', life:10000});
                  }
                }else{
                  this.messageService.add({severity:'info', summary:'Errore', detail:'Il caricamento degli esiti della consegna ad INFRATEL della FASE si è concluso con '+ log.numeroRecordNonProcessati +' errori', life:10000});
                }
               
                
              });
          });
          
        }
    

    async openCaricaAzioni( event: any, pratica:PraticaFlowdy2_Firestore ): Promise<void> {
      this.selectedPratica = pratica;
      this.loadAzioni(event, pratica);
      this.azioniMenuTiered.toggle(event);
    }

    visualizzaNote(pratica: PraticaFlowdy2_Firestore) {
      this.isLoadingResults = true;
      
      this.praticheService.getNote(pratica.id).subscribe(notePratica=>{
        this.isLoadingResults = false;
        this.ref = this.dialogService.open(StoricoNotePraticaComponent, {
          data: {
            pratica: pratica,
            note: notePratica,
          },
          header: "NOTE della pratica "+pratica.cui,
          width: "50%",
          height: "85%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
      });
    }
    getOptionLabel(item: any): string {
      return item.codice + ' - ' + item.label;
    }

    getTipoVincoloOptionLabel(item: any): string {
      return item.tipologiaVincolo.label;
    }
    getTipoVincoloOptionValue(item: any): string {
      return item.tipologiaVincolo.id;
    }

    getOptionValue(item: any): string {
      return item.codice;
    }
    
    loadAzioni(event:any, pratica:PraticaFlowdy2_Firestore){
          this.menuAzioniItems = [];
          if(!this.isImpresa){
            this.menuAzioniItems.push({
              label: "Note",
              icon: 'icona-note-presidio',
              style: {'font-size': '12px'},
              //items:itemsNote,
              command: () => this.visualizzaNote(pratica),
              },
             );
             if(pratica.vincoloTipologiaID != 4){
              this.menuAzioniItems.push(
                {
                   label: "Rendi Lavorabile",
                    icon: 'icona-rendi-lavorabile',
                   style: {  'font-weight': 'bold', 'font-size': '11px'},
                   command: () => this.rendiLavorabile(pratica),
                   disabled: this.isDemo
                 },
               );
               if(pratica.vincoloTipologiaID == 3){}
                
               
            }
            this.menuAzioniItems.push(
              {
                 label: "Modifica Vincolo",
                  icon: 'icona-trasforma-tipo-vincolo',
                 style: {  'font-weight': 'bold', 'font-size': '11px'},
                 command: () => this.modificaVincolo(pratica),
                 disabled: this.isDemo
               },
             );
           }
         /*  this.menuAzioniItems.push(
            {
               label: "Rendi Lavorabile",
                icon: 'icona-rendi-lavorabile',
               style: {  'font-weight': 'bold', 'font-size': '12px'},
               command: () => this.rendiLavorabile(pratica),
             },
           ); */
           
        }
  
    rendiLavorabile(pratica: PraticaFlowdy2_Firestore): void {
      this.showRendiLavorabile = true;
      this.selectedPratica = pratica;
    }

   

    confermaRendiPraticaLavorabile(){
      this.isLoadingResults = true;
      this.praticheService.rendiLavorabilePraticaKO(this.selectedPratica.id).subscribe( {
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({severity:'success', summary:'', detail:'Pratica resa nuovamente lavorabile!', life:5000});
          this.showRendiLavorabile = false;
          this.selectedPratica = null;
          this.isLoadingResults = false;
          this.loadPratiche();
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di comunicazione lavorabilità della pratica'});
            this.isLoadingResults = false;
            this.showRendiLavorabile = false;
            this.selectedPratica = null;
            this.isLoadingResults = false;
        },
        complete: () => {
          
            
        }
      });
      
    }
    

    getTipoSedeAbbreviata(tipoSede:string):string{
      if(tipoSede.startsWith("M")){
        return "Mand. "+tipoSede.charAt(tipoSede.length-1);

      }else{
        return "Agg. "+tipoSede.charAt(tipoSede.length-1);
      }
    }

    modificaVincolo(pratica: PraticaFlowdy2_Firestore): void {
      this.ref = this.dialogService.open(DialogModificaVincolo, {
        data: {
          pratica: pratica,
         
        },
        header: "Modifica vincolo della pratica "+pratica.cui,
        width: "60%",
        height: "35%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((modificaCategoriaVincolo) => {
        if (modificaCategoriaVincolo && modificaCategoriaVincolo.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Categoria del vincolo della pratica '+pratica.cui+' modificata con successo!', life:3000});
          //this.loadPratiche();
        }
      });  
    }


    loadPratiche(){
        this.isLoadingResults = false;
        const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
        let query;
      if(this.isPresidioTIM){
        if(this.filterIsSet){
          if(this.filtroLotto){
            this.logger.info("[KO BANDO 1] PRESIDIO TIM LOADING KO BANDO 1 FILTRO PER LOTTO "+ this.filtroLotto);
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("lotto", "==", this.filtroLotto)
           // .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              this.logger.info("[KO BANDO 1] PRESIDIO TIM LOADING KO BANDO 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("lotto", "==", this.filtroLottoPerFase)
           //   .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");

            }else {
              this.logger.info("[KO BANDO 1] PRESIDIO TIM LOADING KO BANDO 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
             // .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");;

            }
          }else  if(this.filtroInLavorazione){
            this.logger.info("[KO BANDO 1] PRESIDIO TIM LOADING KO BANDO 1 FILTRO PER IN LAVORAZIONE ");

            query= collectionRef
            .where("bando", "==", "BANDO 1")
           // .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");;
          }else  if(this.filtroOda){
            this.logger.info("[KO BANDO 1] PRESIDIO TIM LOADING KO BANDO 1 FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 1")
           //   .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");;
            }else{
              query= collectionRef
              .where("bando", "==", "BANDO 1")
            //  .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");;
            }
           
          }
          
        }else{
          this.logger.info("[KO BANDO 1] PRESIDIO TIM LOADING KO BANDO 1 SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 1")
           //   .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 1")
           // .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }
        }
      }else if(this.isImpresa){
        if(this.filterIsSet){
          if(this.filtroLotto){
            this.logger.info("[KO BANDO 1] LOADING PRATICHE PER AZIENDA KO FILTRO PER LOTTO "+ this.filtroLotto);
           query= collectionRef.where("bando", "==", "BANDO 1")
            .where("lotto", "==", this.filtroLotto)
            .where("idAzienda", "==", this.userService.getUser().azienda.id)
            //.where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");;
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              this.logger.info("[KO BANDO 1] LOADING PRATICHE PER AZIENDA KO FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
            //  .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");;

            }else {
              this.logger.info("[KO BANDO 1] LOADING PRATICHE PER AZIENDA KO FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
             // .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");

            }
          }else  if(this.filtroInLavorazione){
            this.logger.info("[KO BANDO 1] LOADING PRATICHE PER AZIENDA KO FILTRO PER IN LAVORAZIONE ");

            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("idAzienda", "==", this.userService.getUser().azienda.id)
           // .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }else if(this.filtroOda){
            this.logger.info("[KO BANDO 1] LOADING PRATICHE PER AZIENDA KO FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
            //  .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            }else{
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
            //  .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
            }
           
          }else if(this.filtroPratica){
            //this.logger.info("[FASE 2 BANDO 1]] LOADING PRATICHE FASE 1 FILTRO PER PRATICA "+ this.filtroPratica );
            query= collectionRef
            .where("cui", "==", this.filtroPratica)
            .where("idAzienda", "==", this.userService.getUser().azienda.id);
          }
          
        }else{
          this.logger.info("[KO BANDO 1] LOADING PRATICHE PER AZIENDA KO SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAzienda", "==", this.userService.getUser().azienda.id)
             // .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("idAzienda", "==", this.userService.getUser().azienda.id)
           // .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }
        }
      }else if(this.isPresidioSF || this.isAdmin || this.isSuperAdmin || this.isDemo){
        if(this.filterIsSet){
          if(this.filtroLotto){
            this.logger.info("[KO BANDO 1] LOADING KO BANDO 1 FILTRO PER LOTTO "+ this.filtroLotto);
           query= collectionRef.where("bando", "==", "BANDO 1")
            .where("lotto", "==", this.filtroLotto)
           // .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              this.logger.info("[KO BANDO 1] LOADING KO BANDO 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

              query= collectionRef
                .where("bando", "==", "BANDO 1")
                 .where("lotto", "==", this.filtroLottoPerFase)
              //   .where("sopralluogoOk", "==", false)
                .orderBy("dataUltimaModificaFase1");;

            }else {
              this.logger.info("[KO BANDO 1] LOADING KO BANDO 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
                .where("bando", "==", "BANDO 1")
               // .where("sopralluogoOk", "==", false)
                .orderBy("dataUltimaModificaFase1");

            }
          }else if(this.filtroInLavorazione){
            this.logger.info("[KO BANDO 1] LOADING KO BANDO 1 FILTRO PER IN LAVORAZIONE ");
            query= collectionRef
              .where("bando", "==", "BANDO 1")
             // .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
          }else  if(this.filtroOda){
            this.logger.info("[KO BANDO 1] LOADING KO BANDO 1 FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("numeroOda", "==", Number(this.filtroOda))
             // .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            }else{
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("numeroOda", "==", Number(this.filtroOda))
            //  .where("sopralluogoOk", "==", false)
              .orderBy("dataUltimaModificaFase1");
            }
           
          }else if(this.filtroPratica){
            //this.logger.info("[FASE 2 BANDO 1]] LOADING PRATICHE FASE 1 FILTRO PER PRATICA "+ this.filtroPratica );
            query= collectionRef
            .where("cui", "==", this.filtroPratica)
          }
          
        }else{
          this.logger.info("[KO BANDO 1] LOADING KO BANDO 1 SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 1")
           //   .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
             ;
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 1")
           // .where("sopralluogoOk", "==", false)
            .orderBy("dataUltimaModificaFase1");
          }
        }
      }

        
        
        onSnapshot(query, (qs) => {
          this.logger.info("[KO BANDO 1] KO BANDO 1 CARICATE "+ qs.docs.length);

          this.pratiche = [];
          this.praticheFiltrate = [];
          this.isLoadingResults = false;
          qs.forEach((doc) => {
            let pratica = doc.data() as PraticaFlowdy2_Firestore;
            if(pratica.sopralluogoOk===false || pratica.vincoloTipologiaID){
              this.pratiche.push(pratica);
              this.praticheFiltrate.push(pratica);
            }
            /* if(this.isPresidioTIM){
              if(this.filtroStatoInfratel){
                if(pratica.codiceStatoInfratelFase3 === this.filtroStatoInfratel){
  
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                }
              }else{
                if(!this.mostraPraticheCompletate){
                  if(pratica.codiceStatoInfratelFase3 === '3-3' || pratica.codiceStatoInfratelFase3 === '3-4' ){
    
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                }else{
                  if(pratica.codiceStatoInfratelFase3 === '3-3' || pratica.codiceStatoInfratelFase3 === '3-4' || pratica.codiceStatoInfratelFase3 === '3-6'){
    
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                }
                
              }
              

            }else{
              this.pratiche.push(pratica);
              this.praticheFiltrate.push(pratica);
            }  */
           

          });
          this.filtraPratiche(null);
        });
  
    }

  
    scaricaReportPraticheKO(){
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
      this.excelService.exportPraticheKOToExcel(this.pratiche, `pratiche_bando1_KO_${formattedDate}.xlsx`, this.isImpresa);
    }

    
     importaPraticheVincolate(){
        this.importID = uuidv4();
        this.csvbox_importer_vincolateBando1.setUser({
          importID: this.importID,
        });
        this.csvbox_importer_vincolateBando1.openModal();
      }

    filtraPratiche(event: any){
     
      if(event && event.target){
        
        this.praticheDT.filterGlobal(event.target.value, 'contains');
      }else {
       
        if(this._filtroPratiche && Object.keys(this._filtroPratiche).length !== 0){

          this.filterTabellaIsSet = true;
          this.praticheFiltrate = this.pratiche.filter((pratica: PraticaFlowdy2_Firestore) => {
            if(
              ((this._filtroPratiche.tipo?.length ?? 0 ) > 0  && (this._filtroPratiche.tipo.indexOf(pratica.tipoSede) == -1 || this._filtroPratiche.tipo.indexOf(pratica.tipoSedeEffettiva) == -1)) ||
              ((this._filtroPratiche.regione?.length ?? 0  > 0 ) &&  this._filtroPratiche.regione.indexOf(pratica.regione) == -1  )   ||
              ((this._filtroPratiche.impresa?.length ?? 0  > 0 ) &&  this._filtroPratiche.impresa.indexOf(pratica.idAzienda) == -1  )  ||
              ((this._filtroPratiche.causaKO?.length ?? 0  > 0 ) &&  this._filtroPratiche.causaKO.indexOf(pratica.causaSopralluogoKO) == -1  )   ||
             // ((this._filtroPratiche.vincoloKO?.length ?? 0  > 0 ) &&  this._filtroPratiche.vincoloKO.indexOf(pratica.tipoVincolo) == -1  )  ||
              ((this._filtroPratiche.categoriaVincolo?.length ?? 0  > 0 ) &&  this._filtroPratiche.categoriaVincolo.indexOf(pratica.vincoloCategoriaCodice) == -1  ) ||
              ((this._filtroPratiche.tipoVincolo?.length ?? 0  > 0 ) &&  this._filtroPratiche.tipoVincolo.indexOf(pratica.vincoloTipologiaID) == -1  ) ||
              ((this._filtroPratiche.faseVincolo?.length ?? 0  > 0 ) &&  this._filtroPratiche.faseVincolo.indexOf(pratica.vincoloFase) == -1  )

            ){
              return false;
            }
            
            return true;

          });
        }else{
          this.praticheFiltrate = this.pratiche;
        }
      }
    }

    filtraPerStatoInfratel(statoInfratel:string){
      if(!this.filterTabellaIsSet){
        this.praticheDT.filterGlobal(statoInfratel, 'contains');
        this.filterTabellaIsSet = true;
      }else{
        this.praticheDT.clear();
        this.filterTabellaIsSet = false;
      }
    }

    filtraPerCausaKO(causaKO:String){
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.impresa || !this._filtroPratiche.impresa.length) &&
          (!this._filtroPratiche.causaKO || !this._filtroPratiche.causaKO.length)
        ){
          this.praticheDT.filterGlobal(causaKO, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.impresa || !this._filtroPratiche.impresa.length) &&
          (!this._filtroPratiche.causaKO || !this._filtroPratiche.causaKO.length)
        ){
            this.filterTabellaIsSet = false;
        }
      }
     }

    filtraPerOda(numeroOda:number){
      
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheDT.filterGlobal(numeroOda, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
      
    }

    filtraPerBando(oda:OdaAtFirestore){
      if(!this.filterTabellaIsSet){
        this.praticheDT.filterGlobal(oda.bando, 'contains');
        this.filterTabellaIsSet = true;
      }else{
        this.praticheDT.clear();
        this.filterTabellaIsSet = false;
      }
      

      
    }
    filtraPerAzienda(azienda:String){
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheDT.filterGlobal(azienda, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
     }

    filtraPerLotto(lotto:string){
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheFiltrate = this.pratiche.filter((pratica: PraticaFlowdy2_Firestore) => {
            if(
              pratica.lotto === lotto

            ){
              return true;
            }
            
            return false;

          });
          //this.praticheDT.filterGlobal(lotto, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
    
      
    }
    removeFilter(){
      
      if(this.filtroLotto || this.filtroStatoInfratel || this.filtroInLavorazione || this.filtroOda || this.filtroLottoPerFase || this.filtroPratica){
        this.location.replaceState('/pratiche-bando1/fase-2');
        
        this.filterIsSet = false;
        this.filtroLotto = null;
        this.filtroStatoInfratel = null;
        this.filtroInLavorazione = null;
        this.filtroOda = null;
        this.filtroLottoPerFase = null;
        this.filtroPratica = null;
        this.loadPratiche();
      }else{
        if(this._filtroPratiche && 
          (this._filtroPratiche.tipo && this._filtroPratiche.tipo.length > 0) || 
          (this._filtroPratiche.regione && this._filtroPratiche.regione.length > 0 ) ||
          (this._filtroPratiche.impresa && this._filtroPratiche.impresa.length > 0 ) ||
          (this._filtroPratiche.causaKO && this._filtroPratiche.causaKO.length > 0 ) ||
         // (this._filtroPratiche.vincoloKO && this._filtroPratiche.vincoloKO.length > 0 ) ||
          (this._filtroPratiche.categoriaVincolo && this._filtroPratiche.categoriaVincolo.length > 0 ) ||
          (this._filtroPratiche.tipoVincolo && this._filtroPratiche.tipoVincolo.length > 0 ) ||
          (this._filtroPratiche.faseVincolo && this._filtroPratiche.faseVincolo.length > 0 )
        ){
          this._filtroPratiche.tipo      = [];
          this._filtroPratiche.regione   = [];
          this._filtroPratiche.impresa   = [];
          this._filtroPratiche.causaKO   = [];
          this._filtroPratiche.categoriaVincolo = [];
          this._filtroPratiche.tipoVincolo = [];
          this._filtroPratiche.faseVincolo = [];
        }
        this.filterTabellaIsSet = false;
        this.praticheFiltrate = this.pratiche;
        this.praticheDT.clear();
      }
     
     
    }

   

    

    setUserRole(){
      if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "ADMIN"
      ) {
        this.isAdmin = true;
      } else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "SUPERADMIN"
      ) {
        this.isSuperAdmin = true;
      } else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "SMARTFIBER"
      ) {
        this.isPresidioSF = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "PRESIDIO"
      ) {
        this.isPresidioTIM = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
      ) {
        this.isImpresa = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_VERBALI"
      ) {
        this.isDirigenteFirmaVerbali = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
      ) {
        this.isDirigenteFirmaPacchetti = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "PM"
      ) {
        this.isPM = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DEMO"
      ) {
        this.isDemo = true;
      }
    }
  
  }
